import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionBottomContainerProps {
  labelLeft: string;
  labelRight: string;
  textLeft: string;
  textRight: string;
}

export const SectionBottomContainer = ({
  labelLeft,
  labelRight,
  textLeft,
  textRight,
}: SectionBottomContainerProps) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      borderTop: '1px solid #E8E8E8',
      marginTop: '10px',
      paddingTop: '5px',
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Typography sx={{
          fontSize: '10px',
          fontWeight: '400',
          color: '#9D9D9D',
        }}>
          {labelLeft}
        </Typography>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '700',
          fontSize: '12px',
        }}>
          {textLeft}
        </Typography>
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}>
        <Typography sx={{
          fontSize: '10px',
          fontWeight: '400',
          color: '#9D9D9D',
        }}>
          {labelRight}
        </Typography>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '700',
          fontSize: '12px',
        }}>
          {textRight}
        </Typography>
      </Box>
    </Box>
  );
};
